import NavigationContextInterface, { NavigationAction } from "@app/Interface/NavigationContextInterface";
import TypeAssertions from "@app/utils/TypeAssertions";

/**
 * Handles getting and updating current user data. 
 * Updated to persist data between tabs
 * see: https://dev.to/bigaru/creating-persistent-synchronized-global-store-using-react-hooks-in-typescript-209a#persistence
 * 
 * @param navigationState 
 * @param NavigationAction 
 * @returns 
 */
export const navigationContextReducer = (navigationState: NavigationContextInterface, NavigationAction: NavigationAction): NavigationContextInterface => {

    let updatedState: NavigationContextInterface;

    switch (NavigationAction.type) {

        case "GET":
            return navigationState;

        case "ADD":

            // copy original state, add the user information
            updatedState = { ...navigationState, fpuRoutes: NavigationAction.payload };

            return updatedState;

        case "UPDATE":

            // copy original state, use the updated user information
            updatedState = { ...navigationState, fpuRoutes: NavigationAction.payload };

            return updatedState;

        case "SYNC_NAVIGATION":

            // copy original state, use the updated user information
            updatedState = { ...navigationState, fpuRoutes: NavigationAction.payload };

            return updatedState;

        default:
            // returns error if unhandled case  
            return TypeAssertions.assertNeverNavigationAction(NavigationAction);

    }

}